import React, { useCallback } from "react"
import { navigate } from "gatsby"

import useAddToCart from "utils/useAddToCart"
import { formatCurrency } from "utils/currency"
import totalNavHeight from "utils/totalNavHeight"

import ErrorBoundary from "components/error-boundary"
import { Button, VerticalSeparator, IconContainer, RightArrow, AffirmContainer } from "./styles"

const AffirmScript = React.lazy(() => import("components/common/affirm-script"))

const CTAButton = ({
  iconRight,
  arrowRight,
  price,
  children,
  link,
  anchor,
  addClassToCart,
  addProductToCart,
  addSubscriptionToCart,
  displayPriceOnButton = false,
  elRef,
  actionNone,
  dataId,
  mailToAddress,
  showInstallmentPaymentLanguage,
  hasNavigation,
  index,
  ...props
}) => {
  const request = useAddToCart()

  const onClick = useCallback(() => {
    if (mailToAddress) {
      document.location = `mailto:${mailToAddress}`
      return
    }
    if (request.addingToCart) return
    if (actionNone) return
    if (anchor) {
      window.history.pushState({}, "", anchor)
      const element = document.querySelector(anchor)
      if (element) {
        window.scrollTo({
          top: element.offsetTop - totalNavHeight(),
          left: 0,
          behavior: "smooth",
        })
      }
    }

    if (link) {
      if (link.match(/^\//)) {
        navigate(link)
        return
      }
      document.location = link
      return
    }

    if (addClassToCart) {
      const { classId, classTitle, classPrice, redirect, paymentType, isBundle } = addClassToCart
      request.addClassToCart(classId, classTitle, classPrice, redirect, paymentType, isBundle)
    }

    request.getCartToken(addProductToCart, addSubscriptionToCart)
  }, [
    actionNone,
    link,
    anchor,
    addClassToCart,
    addProductToCart,
    addSubscriptionToCart,
    request.addProductToCart,
    request.addingToCart,
  ])

  return (
    <>
      <Button
        {...props}
        data-exp-id={dataId}
        ref={elRef}
        type="button"
        onClick={onClick}
        notEnabled={request.addingToCart}
        hasNavigation={hasNavigation}
        index={index}
      >
        {displayPriceOnButton && (
          <>
            {price && formatCurrency(price, true)}
            {price && <VerticalSeparator>&nbsp;</VerticalSeparator>}
          </>
        )}
        {!request.addingToCart && children}
        {request.addingToCart && <span>Adding to cart ...</span>}
        {iconRight && <IconContainer>{iconRight}</IconContainer>}
        {arrowRight && <RightArrow />}
      </Button>
      {showInstallmentPaymentLanguage && (
        <AffirmContainer>
          <ErrorBoundary componentType="AffirmScript">
            <React.Suspense>
              <AffirmScript />
            </React.Suspense>
          </ErrorBoundary>
          <p className="affirm-as-low-as" data-amount={price ? price * 100 : null}>
            {" "}
          </p>
        </AffirmContainer>
      )}
    </>
  )
}

export default CTAButton
